(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["foundation-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.swiper-slider-section').forEach(function (section) {
      const swiperElement = section.querySelector('.swiper');

      if (!swiperElement || swiperElement.swiper) return;

      const pagination  = section.querySelector('.swiper-pagination');
      const prevBtn     = section.querySelector('.swiper-btn-prev');
      const nextBtn     = section.querySelector('.swiper-btn-next');
      const autoplayDelay   = Number(section.dataset.autoplay) || 5000;
      const autoplayEnabled = section.dataset.autoplayEnabled === 'true';

      const updateCenteredProgress = function (swiper) {
        if (!pagination) return;
        const fill = pagination.querySelector('.swiper-pagination-progressbar-fill');
        if (!fill) return;
        const realSlideCount = swiper.slides.length - (swiper.loopedSlides * 2);
        const totalSlides    = realSlideCount > 0 ? realSlideCount : swiper.slides.length;
        const activeIndex    = swiper.realIndex || 0;
        const segmentWidth   = 1 / Math.max(totalSlides, 1);
        const segmentStart   = activeIndex * segmentWidth;
        fill.style.transform = 'translate3d(' + (segmentStart * 100) + '%, 0, 0) scaleX(' + segmentWidth + ')';
      };

      const swiperInstance = new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 24,
        speed: 1200,
        loop: false,
        effect: 'slide',
        autoplay: autoplayEnabled
          ? { delay: autoplayDelay, disableOnInteraction: false }
          : false,
        pagination: {
          el: pagination,
          type: 'progressbar'
        },
        on: {
          init: updateCenteredProgress,
          slideChange: updateCenteredProgress
        }
      });

      updateCenteredProgress(swiperInstance);

      /* Arrow buttons */
      if (prevBtn) prevBtn.addEventListener('click', function () { swiperInstance.slidePrev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { swiperInstance.slideNext(); });

      /* Mouse wheel navigation */
      let isScrolling = false;

      swiperElement.addEventListener('wheel', function (e) {
        e.preventDefault();
        if (isScrolling) return;
        isScrolling = true;
        if (e.deltaY > 0 || e.deltaX > 0) {
          swiperInstance.slideNext();
        } else {
          swiperInstance.slidePrev();
        }
        setTimeout(function () { isScrolling = false; }, 1300);
      }, { passive: false });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.expert-grid-slider').forEach(function (section) {
      const swiperElement = section.querySelector('.swiper');

      if (!swiperElement || swiperElement.swiper) return;

      const pagination = section.querySelector('.swiper-pagination');
      const prevBtn = section.querySelector('.swiper-btn-prev');
      const nextBtn = section.querySelector('.swiper-btn-next');
      const autoplayDelay = Number(section.dataset.autoplay) || 5000;
      const autoplayEnabled = section.dataset.autoplayEnabled === 'true';
      const updatePagedProgress = function (swiper) {
        if (!pagination) return;

        const fill = pagination.querySelector('.swiper-pagination-progressbar-fill');
        if (!fill) return;

        const pageCount = Math.max(swiper.snapGrid.length, 1);
        const currentPage = Math.min(swiper.snapIndex || 0, pageCount - 1);
        const segmentWidth = 1 / pageCount;

        fill.style.transform =
          'translate3d(' + (currentPage * segmentWidth * 100) + '%, 0, 0) scaleX(' + segmentWidth + ')';
      };

      const swiperInstance = new Swiper(swiperElement, {
        slidesPerView: 1.12,
        slidesPerGroup: 1,
        spaceBetween: 14,
        speed: 700,
        loop: false,
          mousewheel: true,
        autoplay: autoplayEnabled
          ? {
              delay: autoplayDelay,
              disableOnInteraction: false
            }
          : false,
        pagination: {
          el: pagination,
          type: 'progressbar'
        },
        on: {
          init: updatePagedProgress,
          slideChange: updatePagedProgress,
          breakpoint: updatePagedProgress,
          resize: updatePagedProgress
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 14
          },
          990: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 14
          }
        }
      });

      updatePagedProgress(swiperInstance);

      if (prevBtn) prevBtn.addEventListener('click', function () { swiperInstance.slidePrev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { swiperInstance.slideNext(); });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
